"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $mywayList = document.querySelector('.myway__list');
exports.default = $mywayList === null || $mywayList === void 0 ? void 0 : $mywayList.addEventListener('click', function (e) {
    var $target = e.target;
    if ($target.matches('.showmore__btn')) {
        var $popup_1 = $target.nextElementSibling;
        $popup_1.classList.add('active');
        $target.classList.add('hide');
        // close popup
        $popup_1.addEventListener('mouseleave', function () {
            $popup_1 === null || $popup_1 === void 0 ? void 0 : $popup_1.classList.remove('active');
            $target.classList.remove('hide');
        });
    }
});
